import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button,
    TextField,
    CircularProgress,
    Typography,
    Grid,
    Avatar,
    Badge,
} from "@material-ui/core";

import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Alert from '@material-ui/lab/Alert';

import CountrySelect from "src/shared_modules/veu-visitors-core/components/common/country-select";
import FoaSelect from "src/shared_modules/veu-visitors-core/components/common/foa-select";
import PhoneInput from "src/shared_modules/veu-visitors-core/components/common/phone-input";

import {
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    updateProfile,
} from 'src/shared_modules/veu-visitors-core/actions/user';

import MarketingConsentButton from "src/shared_modules/veu-visitors-core/components/common/marketingConsentButton";

class PopoverProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error : "",
            canSend : false,
            isBusy : false,
            failed: false,
            fields: {
                avatar : "",
                formOfAdress : "",
                title : "",
                firstname : "",
                lastname : "",
                company : "",
                position : "",
                city : "",
                phone : "",
                aboutme : "",
                email : "",
                country : "",
                department : "",
                division : "",
                uploadPhoto : null,
            },
            fieldErrors : {
            },

        }
    }

    componentDidMount() {
        this.setState({ fields: {
            avatar : this.props.user.profile.photo,
            formOfAdress : this.props.user.profile.formOfAdress,
            title : this.props.user.profile.title,
            firstname : this.props.user.profile.firstname,
            lastname : this.props.user.profile.lastname,
            company : this.props.user.profile.company,
            position : this.props.user.profile.position,
            city : this.props.user.profile.city,
            phone : this.props.user.profile.phone,
            aboutme : this.props.user.profile.aboutme,
            email: this.props.user.profile.email,
            country : this.props.user.profile.country,
            department : this.props.user.profile.department,
            division : this.props.user.profile.division,
            uploadPhoto : null,
        }});

        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleAvatarChange = this.handleAvatarChange.bind(this);
        this.renderAvatar = this.renderAvatar.bind(this);
        this.renderAvatarInput = this.renderAvatarInput.bind(this);
    }

    clickCancel() {
        // TODO send cancel to Plazz API if isBusy = true

        this.setState({
            isBusy: false,
            fields: {
                avatar : "",
                formOfAdress : "4",
                title : "",
                firstname : "",
                lastname : "",
                company : "",
                position : "",
                city : "",
                phone : "",
                aboutme : "",
                email : "",
                country : "",
                department : "",
                division : "",
                uploadPhoto : null,
            },
            fieldErrors : {
            },
            error: "", // errorcode
            canSend: false,
            failed: false,
        });
        this.props.hidePopover("Profile");
    }

    async clickSend() {
        if( this.state.isBusy || !this.state.canSend )
            return;

        this.setState({
            isBusy: true,
            failed: false,
            error: "",
        });

        let error = await this.props.updateProfile(
                this.state.fields
            );

        if( error !== false ) {
            this.setState({
                failed: true,
                isBusy: false,
                error: "popovers.profile.failed." + error,
                fieldErrors :  this.markFieldErrors(error)
             });

        } else {
            this.setState({
                isBusy: false,
                canSend: false
            });
            //this.props.hidePopover("Profile");
        }

    }

    markFieldErrors( errorcode ) {
        let fieldErrors = {};
        if( errorcode === "imageTooLarge" ) {
            //console.error("markFieldErrors - imageTooLarge");
            fieldErrors["uploadPhoto"] = true;
        } else  {
            //console.error("markFieldErrors - errorcode: " + errorcode);
            // maybe we have additional error codes from plazz here

            // but in all other cases we mark the fields
            fieldErrors[errorcode] = true;
        }
        return fieldErrors;
    }

    validateInput(value) {
        // just not empty
        if( value === undefined || value === null || value.trim() === "" )
            return false;

        return true;
    }

    validateFields() {
        let canSend = true;
        let fields = this.state.fields;

        if( !this.validateInput(fields["firstname"]) )
            canSend = false;

        if( !this.validateInput(fields["lastname"]) )
            canSend = false;

        return canSend;
    }

    handlePhoneChange( val ) {
        let fields = this.state.fields;
        fields["phone"] = val;

        let canSend = this.validateFields();

        this.setState({
                fields : fields,
                canSend : canSend,
            });
    }

    handleInputChange( field, event ) {
        event.preventDefault();
        // update the field value
        let fields = this.state.fields;
        let val = event.target.value;
        fields[field] = val;

        let canSend = this.validateFields();

        this.setState({
                fields : fields,
                canSend : canSend,
                fieldErrors: {},
            });
    }

    handleAvatarChange( event ) {
        var file = event.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            let fields = this.state.fields;
            fields["uploadPhoto"] = reader.result;

            let canSend = this.validateFields();

            this.setState({
                fields : fields,
                canSend : canSend,
            })
        };

        reader.onerror = function (error) {
            console.error('Error: ', error);
        }
    }


    renderSubheadline( title ) {
        return(<Grid item xs={12}>
                <Typography color="primary" variant="subtitle2"
                        style={{ marginBottom: 8, marginTop: 8 }}
                    >
                    <Translate>{title}</Translate>
                </Typography>
            </Grid>);
    }

    renderButtonBar() {
        return(<div className="user-form-button-bar none-scroll">
                    <Button variant="contained"
                            color="secondary"
                            onClick={() =>{ this.clickSend();} }
                            type="submit"
                            endIcon={ this.state.isBusy && <CircularProgress color="inherit" size={20} /> }
                        >
                        <Translate>popovers.profile.send</Translate>
                    </Button>
                    <div className="marketing-consent-button">
                      <MarketingConsentButton />
                    </div>
            </div>);
    }

    renderAvatar() {
        const me = this.props.user.profile;
        if( !me )
            return null;

        let alt = "Upload a photo";

        if( this.state.fields.avatar === "" && this.state.fields.uploadPhoto === null ) {
            return(<Avatar alt={alt} className="profile-avatar placeholder">
                        <AccountCircleIcon color="primary"/>
                    </Avatar>);
        }
        let url = null;
        if( this.state.fields.uploadPhoto !== null )
            url = this.state.fields.uploadPhoto;
        else
            url = this.state.fields.avatar;

        return(<Avatar className="profile-avatar photo" alt={alt} src={url}/>);
    }

    renderAvatarInput() {

        return(<Grid container item
                    xs={12}
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                <label htmlFor="uploadPhoto">
                <input
                   style={{ display: 'none' }}
                   id="uploadPhoto"
                   name="uploadPhoto"
                   type="file"
                   accept="image/x-png,image/gif,image/jpeg"
                   onChange={ this.handleAvatarChange }
                 />
                <Badge color="secondary"
                        className="profile-upload"
                        badgeContent={<PhotoCameraIcon />}
                        overlap="circle"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                    >
                    { this.renderAvatar() }
                </Badge>
                </label>
            </Grid>);

    }

    renderPersonalInputs() {
        return(<React.Fragment>
                { this.renderSubheadline("popovers.profile.personal-infos") }
                <Grid container item
                        xs={12}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >
                    <Grid container item
                            xs={12}
                            md={6}
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                            className="cols-2-rows"
                        >
                        <FoaSelect
                                style={{ marginBottom: 12 }}
                                value={this.state.fields["formOfAdress"]}
                                onChange={(e)=>{this.handleInputChange("formOfAdress",e);}}
                            />
                    </Grid>
                    <Grid container item
                            xs={12}
                            md={6}
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                            className="cols-2-rows"
                        >
                        <TextField id="title"  key="title"
                            fullWidth
                            style={{ marginBottom: 12 }}
                            label={<Translate>person-labels.title</Translate>}
                            variant="outlined"
                            value={this.state.fields["title"]}
                            onChange={(e)=>{this.handleInputChange("title",e);}}
                        />
                    </Grid>
                </Grid>
                <Grid container item
                        xs={12}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >
                        <TextField id="firstname"  key="firstname"
                                required
                                style={{ marginBottom: 12 }}
                                fullWidth
                                label={<Translate>person-labels.firstname</Translate>}
                                variant="outlined"
                                value={this.state.fields["firstname"]}
                                error={this.state.fieldErrors["firstname"]}
                                onChange={(e)=>{this.handleInputChange("firstname",e);}}
                            />
                    </Grid>
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >
                        <TextField id="lastname"  key="lastname"
                                required
                                style={{ marginBottom: 12 }}
                                fullWidth
                                label={<Translate>person-labels.lastname</Translate>}
                                variant="outlined"
                                value={this.state.fields["lastname"]}
                                error={this.state.fieldErrors["lastname"]}
                                onChange={(e)=>{this.handleInputChange("lastname",e);}}
                            />
                    </Grid>
                </Grid>
            </React.Fragment>);
    }

    renderCompanyInputs() {
        return(<React.Fragment>
                { this.renderSubheadline("popovers.profile.company-infos") }
                <Grid container item
                        xs={12}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >
                        <TextField id="company"  key="company"
                                fullWidth
                                style={{ marginBottom: 12 }}
                                label={<Translate>person-labels.company</Translate>}
                                variant="outlined"
                                value={this.state.fields["company"]}
                                onChange={(e)=>{this.handleInputChange("company",e);}}
                            />
                    </Grid>
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >
                        <TextField id="department"  key="department"
                                fullWidth
                                style={{ marginBottom: 12 }}
                                label={<Translate>person-labels.department</Translate>}
                                variant="outlined"
                                value={this.state.fields["department"]}
                                onChange={(e)=>{this.handleInputChange("department",e);}}
                            />
                    </Grid>
                </Grid>

                <Grid container item
                        xs={12}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >
                        <TextField id="division"  key="division"
                                fullWidth
                                style={{ marginBottom: 12 }}
                                label={<Translate>person-labels.division</Translate>}
                                variant="outlined"
                                value={this.state.fields["division"]}
                                onChange={(e)=>{this.handleInputChange("division",e);}}
                            />
                    </Grid>
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >
                        <TextField id="positon"  key="positon"
                                fullWidth
                                style={{ marginBottom: 12 }}
                                label={<Translate>person-labels.position</Translate>}
                                variant="outlined"
                                value={this.state.fields["position"]}
                                onChange={(e)=>{this.handleInputChange("position",e);}}
                            />
                    </Grid>
                </Grid>

                <Grid container item
                        xs={12}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >

                        <CountrySelect
                                required
                                style={{ marginBottom: 12 }}
                                value={this.state.fields["country"]}
                                onChange={(e)=>{this.handleInputChange("country",e);}}
                            />
                    </Grid>
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >
                        <TextField id="city"  key="city"
                                fullWidth
                                style={{ marginBottom: 12 }}
                                label={<Translate>person-labels.city</Translate>}
                                variant="outlined"
                                value={this.state.fields["city"]}
                                onChange={(e)=>{this.handleInputChange("city",e);}}
                            />
                    </Grid>
                </Grid>

                <Grid container item
                        xs={12}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >
                    <Grid item className="cols-2-rows"
                            xs={12}
                            md={6}
                        >

                        <PhoneInput
                                value={this.state.fields["phone"]}
                                onChange={this.handlePhoneChange}
                                style={{ marginBottom: 12 }}
                            />
                    </Grid>
                </Grid>

            </React.Fragment>);
    }

    renderAboutMeInput() {
        return(<React.Fragment>
                { this.renderSubheadline("person-labels.aboutme") }
                <Grid container item
                        xs={12}
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                    >
                    <TextField id="aboutme"
                              multiline
                              rows={5}
                              fullWidth
                              style={{ marginBottom: 12 }}
                              label={<Translate>person-labels.aboutme</Translate>}
                              variant="outlined"
                              value={this.state.fields["aboutme"]}
                              onChange={(e)=>{this.handleInputChange("aboutme",e);}}
                             />


                </Grid>



            </React.Fragment>);


    }

    render() {

        if( !this.props.showProfile )
            return(null);

        return (<React.Fragment>
                    <form onSubmit={(e)=>{e.preventDefault();} } >
                        <Grid container
                                xl={12}
                                direction="column"
                                justify="flex-start"
                                alignItems="flex-start"
                            >
                            { this.renderAvatarInput() }
                            { this.renderPersonalInputs() }
                            { this.renderCompanyInputs() }
                            { this.renderAboutMeInput() }
                            {this.state.failed && <div className="user-form-alert"><Alert variant="outlined" severity="error">
                                    <Translate>{this.state.error}</Translate>
                                </Alert></div>}
                        </Grid>
                    </form>
                { this.renderButtonBar() }
            </React.Fragment>);
    }
}

PopoverProfile.propTypes = {
    meaconfig: PropTypes.object,
    eventpath: PropTypes.string,
    showProfile: PropTypes.bool,
    user : PropTypes.object,
};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        showProfile : state.popovers.showProfile,
        user: state.user,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
    updateProfile,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(PopoverProfile);
